import "./stock-ticker-block.scss";